import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "@/lib/api";
import { useResource } from "@/pwa/useResource";
import { relativeLabel, shortDate, upcomingPlanned } from "@/lib/agenda";
import { DataUnavailable } from "@/components/pwa/OfflineBanner";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { CalendarClock, ArrowRight } from "lucide-react";

export const UpcomingAppointments = () => {
  const nav = useNavigate();
  const { data, unavailable } = useResource(
    useCallback(async () => { const r = await apiGet("/sessions", { params: { status: "Pianificata" } }); return { data: r.data, stale: r.stale }; }, []),
    []
  );
  const next = upcomingPlanned(data || [], 3);

  return (
    <CollapsibleSection
      id="dash-upcoming"
      testid="upcoming-appointments"
      card
      title="Prossimi appuntamenti"
      icon={CalendarClock}
      iconClass="text-primary"
      titleClass="font-head text-lg font-bold"
      action={
        <button data-testid="upcoming-see-agenda" onClick={() => nav("/agenda")} className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline shrink-0">
          Vedi agenda <ArrowRight className="h-4 w-4" />
        </button>
      }
    >
      {unavailable ? (
        <DataUnavailable testid="upcoming-unavailable" />
      ) : next.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="upcoming-empty">Nessun appuntamento pianificato.</p>
      ) : (
        <div className="space-y-2" data-testid="upcoming-list">
          {next.map((s) => {
            const rel = relativeLabel(s.date);
            return (
              <button key={s.id} data-testid={`upcoming-${s.id}`} onClick={() => s.dog_ids?.[0] && nav(`/cani/${s.dog_ids[0]}`)}
                className="w-full text-left rounded-xl border border-border bg-secondary/30 p-3 hover:border-primary transition-colors">
                <div className="text-xs font-semibold text-primary">{rel || shortDate(s.date)} · {s.start_time || "—"}</div>
                <div className="text-sm font-medium truncate">{(s.dog_names || []).join(", ") || "—"} — {s.service_type}</div>
              </button>
            );
          })}
        </div>
      )}
    </CollapsibleSection>
  );
};
